(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["solo-no-arrows"] && !Shopify.designMode) return;
  try {
    (() => {
    const arrowPattern = /[↗↖↘↙→←↑↓➜➝➞➟➠⇢]/g;
    let frame = 0;

    function clean(rootNode) {
      const root = rootNode || document.body;
      if (!root) return;
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      const nodes = [];

      while (walker.nextNode()) {
        const node = walker.currentNode;
        const parent = node.parentElement;
        if (!parent || parent.closest('script, style, template, noscript')) continue;
        arrowPattern.lastIndex = 0;
        if (arrowPattern.test(node.nodeValue || '')) nodes.push(node);
      }

      nodes.forEach((node) => {
        node.nodeValue = (node.nodeValue || '').replace(arrowPattern, '').replace(/\s{2,}/g, ' ');
      });

      document.querySelectorAll('.solo-contact__arrow').forEach((icon) => {
        if (!icon.textContent.trim()) icon.hidden = true;
      });
    }

    function schedule(rootNode) {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = 0;
        clean(rootNode || document.body);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => clean(document.body), { once: true });
    } else {
      clean(document.body);
    }

    document.addEventListener('shopify:section:load', (event) => clean(event.target));
    new MutationObserver(() => schedule(document.body)).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["solo-sales-ticker-5"] && !Shopify.designMode) return;
  try {
    (() => {
    const placeOfferStrip = () => {
      const strip = document.getElementById('solo-global-offer-strip');
      const main = document.getElementById('MainContent');

      if (!strip || !main) return;

      const sections = Array.from(main.children).filter(
        (element) => element.classList.contains('shopify-section') && element !== strip
      );

      if (sections.length > 0) {
        const middleIndex = Math.max(0, Math.ceil(sections.length / 2) - 1);
        sections[middleIndex].after(strip);
      } else {
        main.append(strip);
      }

      strip.classList.add('is-ready');
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', placeOfferStrip, { once: true });
    } else {
      placeOfferStrip();
    }

    document.addEventListener('shopify:section:load', placeOfferStrip);
    document.addEventListener('shopify:section:reorder', placeOfferStrip);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["solo-wishlist"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.getElementById('SoloWishlist');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const key = 'solo_wishlist_v1';
    const dialog = root.querySelector('[data-swl-dialog]');
    const itemsNode = root.querySelector('[data-swl-items]');
    const emptyNode = root.querySelector('[data-swl-empty]');
    const strings = {
      add: root.dataset.addLabel,
      remove: root.dataset.removeLabel,
      empty: root.dataset.emptyLabel,
      view: root.dataset.viewLabel,
    };
    let memoryItems = [];
    let frame = 0;

    const heartMarkup = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z"/></svg>';

    function normalizeUrl(value) {
      try {
        return new URL(value, window.location.origin).pathname;
      } catch (error) {
        return value || '';
      }
    }

    function readItems() {
      try {
        const parsed = JSON.parse(window.localStorage.getItem(key) || '[]');
        memoryItems = Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        memoryItems = Array.isArray(memoryItems) ? memoryItems : [];
      }
      return memoryItems;
    }

    function writeItems(nextItems) {
      memoryItems = nextItems;
      try {
        window.localStorage.setItem(key, JSON.stringify(nextItems));
      } catch (error) {
        memoryItems = nextItems;
      }
      render();
    }

    function productFromNode(node) {
      const link = node.matches('a[href*="/products/"]') ? node : node.querySelector('a[href*="/products/"]');
      if (!link) return null;
      const image = node.querySelector('img');
      const titleNode = node.querySelector('.sf5-product__info h3, .sf5-product__info h4, .product-card__title, [class*="product-title"]');
      const priceNode = node.querySelector('.sf5-product__info p, .price, [class*="price"]');
      return {
        url: normalizeUrl(link.getAttribute('href')),
        title: (link.getAttribute('aria-label') || titleNode?.textContent || '').trim(),
        image: image?.currentSrc || image?.src || '',
        price: (priceNode?.textContent || '').replace(/\s+/g, ' ').trim(),
      };
    }

    function productFromButton(button) {
      return {
        url: normalizeUrl(button.dataset.swlUrl),
        title: button.dataset.swlTitle || '',
        image: button.dataset.swlImage || '',
        price: button.dataset.swlPrice || '',
      };
    }

    function toggle(product) {
      if (!product || !product.url) return;
      const current = readItems();
      const exists = current.some((item) => item.url === product.url);
      const next = exists ? current.filter((item) => item.url !== product.url) : [...current, product];
      writeItems(next);
    }

    function createHeartButton(product) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'swl-card-heart';
      button.dataset.swlUrl = product.url;
      button.dataset.swlTitle = product.title;
      button.dataset.swlImage = product.image;
      button.dataset.swlPrice = product.price;
      button.innerHTML = heartMarkup;
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        toggle(productFromButton(button));
      });
      return button;
    }

    function mountCard(node) {
      if (node.dataset.swlProcessed === 'true') return;
      const product = productFromNode(node);
      if (!product?.url) return;
      node.dataset.swlProcessed = 'true';
      const button = createHeartButton(product);

      if (node.matches('a.sf5-product')) {
        const wrapper = document.createElement('div');
        wrapper.className = 'swl-card-wrap';
        node.before(wrapper);
        wrapper.append(node, button);
      } else {
        node.classList.add('swl-card-host');
        node.append(button);
      }
    }

    function mountProductPage() {
      const template = document.getElementById('SoloWishlistProductTemplate');
      if (!template || document.querySelector('.swl-product-action')) return;
      const target = document.querySelector('.buy-buttons-block, .product-form-buttons, product-form');
      if (!target) return;
      const button = template.content.firstElementChild.cloneNode(true);
      button.addEventListener('click', () => toggle(productFromButton(button)));
      target.insertAdjacentElement('afterend', button);
    }

    function scan() {
      mountLauncher();
      document.querySelectorAll('product-card.product-card:not([data-placeholder]), a.sf5-product[href*="/products/"]').forEach(mountCard);
      mountProductPage();
      refreshButtons();
    }

    function refreshButtons() {
      const saved = new Set(readItems().map((item) => item.url));
      document.querySelectorAll('[data-swl-url]').forEach((button) => {
        const active = saved.has(normalizeUrl(button.dataset.swlUrl));
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
        button.setAttribute('aria-label', active ? strings.remove : strings.add);
        const label = button.querySelector('span');
        if (label && button.classList.contains('swl-product-action')) label.textContent = active ? strings.remove : strings.add;
      });
      document.querySelectorAll('.swl__launcher [data-swl-count]').forEach((count) => {
        count.textContent = String(saved.size);
      });
    }

    function createWishlistItem(item) {
      const article = document.createElement('article');
      article.className = 'swl-item';

      const link = document.createElement('a');
      link.className = 'swl-item__link';
      link.href = item.url;
      link.setAttribute('aria-label', `${strings.view}: ${item.title}`);

      const media = document.createElement('div');
      media.className = 'swl-item__media';
      if (item.image) {
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = item.title;
        image.loading = 'lazy';
        media.append(image);
      }

      const details = document.createElement('div');
      const title = document.createElement('h3');
      title.className = 'swl-item__title';
      title.textContent = item.title;
      details.append(title);
      if (item.price) {
        const price = document.createElement('p');
        price.className = 'swl-item__price';
        price.textContent = item.price;
        details.append(price);
      }
      link.append(media, details);

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'swl-item__remove';
      remove.textContent = '×';
      remove.setAttribute('aria-label', `${strings.remove}: ${item.title}`);
      remove.addEventListener('click', () => {
        writeItems(readItems().filter((savedItem) => savedItem.url !== item.url));
      });

      article.append(link, remove);
      return article;
    }

    function render() {
      const saved = readItems();
      itemsNode.replaceChildren(...saved.map(createWishlistItem));
      emptyNode.classList.toggle('is-visible', saved.length === 0);
      refreshButtons();
    }

    function openDialog() {
      render();
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      document.documentElement.classList.add('swl-open');
    }

    function closeDialog() {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      document.documentElement.classList.remove('swl-open');
    }

    const launcher = root.querySelector('[data-swl-open]');
    const headerBreakpoint = window.matchMedia('(max-width: 1180px)');

    function mountLauncher() {
      const header = document.querySelector('[data-solo-header]');
      if (!header || !launcher) return;
      const target = header.querySelector(headerBreakpoint.matches ? '.sfh__mobile-actions' : '.sfh__actions');
      if (!target || launcher.parentElement === target) return;
      const cartLink = target.querySelector('.sfh__cart-link, .sfh__mobile-cart-head');
      target.insertBefore(launcher, cartLink);
    }

    launcher.addEventListener('click', openDialog);
    root.querySelector('[data-swl-close]').addEventListener('click', closeDialog);
    dialog.addEventListener('close', () => document.documentElement.classList.remove('swl-open'));
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });
    window.addEventListener('storage', render);
    document.addEventListener('shopify:section:load', scan);
    if (typeof headerBreakpoint.addEventListener === 'function') {
      headerBreakpoint.addEventListener('change', mountLauncher);
    } else {
      headerBreakpoint.addListener(mountLauncher);
    }

    const observer = new MutationObserver(() => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = 0;
        scan();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });

    scan();
    render();
  })();
  } catch(e) { console.error(e); }
})();

})();
